import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../auth/AuthProvider";
import { Link, useParams } from "react-router-dom";

export default function PhaseLayout5() {
  const [phase, setPhase] = useState({});
  const [showPhase1, setShowPhase1] = useState({
    id1: 0,
    show: false,
  });

  // const [userQuestion1, setUserQuestion1] = useState([]);
  // const [userQuestion2, setUserQuestion2] = useState([]);
  // const [userQuestion3, setUserQuestion3] = useState([]);
  // const [userQuestion4, setUserQuestion4] = useState([]);

  const [question, setQuestion] = useState([]);

  const [change, setChange] = useState(false);

  const {
    refreshTrigger,
    userQuestion5_1,
    userQuestion5_2,
    userQuestion5_3,
    userQuestion5_4,
    userQuestion5_5,
    setUserQuestion5_1,
    setUserQuestion5_2,
    setUserQuestion5_3,
    setUserQuestion5_4,
    setUserQuestion5_5,
    googleUserQuestion5_1,
    googleUserQuestion5_2,
    googleUserQuestion5_3,
    googleUserQuestion5_4,
    googleUserQuestion5_5,
    setGoogleUserQuestion5_1,
    setGoogleUserQuestion5_2,
    setGoogleUserQuestion5_3,
    setGoogleUserQuestion5_4,
    setGoogleUserQuestion5_5,
    googleUser,
    user,
    phase5Complete,
    setPhase5Complete,
    apiUrl,
  } = useContext(AuthContext);

  const [precentCompletion, setPrecentCompletion] = useState(0);

  const { id, phaseTitle, hashed } = useParams();

  useEffect(() => {
    axios
      .get(`${apiUrl}/phase/byTheme/${id}`)
      .then((response) => {
        setPhase(response.data[4]);
      })
      .catch((err) => {});

    axios
      .get(`${apiUrl}/question/byPhaseAndTheme/Phase 5/${id}`)
      .then((response) => {
        setQuestion(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (!user && !googleUser) return;

    const username = user?.username;
    const googleEmail = googleUser?.email;

    if (username) {
      axios
        .get(
          `${apiUrl}/user-question/byUserInfo/${username}/${id}/${phase && phase.title}`,
        )
        .then((response) => {
          const sorted = response.data.sort((a, b) => b.id - a.id);

          setPrecentCompletion(sorted[0]?.questionIndex);

          const sorted1 = sorted.filter((a) => a.questionIndex === 5);
          if (
            sorted1.length > 0 &&
            sorted1[0]?.phaseName === "Phase 5" &&
            sorted1[0]?.questionNumber === "Question 5_5"
          ) {
            setPhase5Complete(true);
            setPrecentCompletion(sorted1[0]?.questionIndex);
          }
        })
        .catch((err) => {});

      axios
        .get(`${apiUrl}/user-question/byUserAndTheme/${username}/${id}`, {
          withCredentials: true,
        })
        .then((response) => {
          const data = response.data;

          // store only user's responses for this phase
          const phase1 = data.filter(
            (uq) => uq.phaseName === "Phase 5" && username === uq.userUsername,
          );

          // now isolate each question
          setUserQuestion5_1(
            phase1.filter((uq) => uq.questionText === "Question 5_1"),
          );
          setUserQuestion5_2(
            phase1.filter((uq) => uq.questionText === "Question 5_2"),
          );
          setUserQuestion5_3(
            phase1.filter((uq) => uq.questionText === "Question 5_3"),
          );
          setUserQuestion5_4(
            phase1.filter((uq) => uq.questionText === "Question 5_4"),
          );
          setUserQuestion5_5(
            phase1.filter((uq) => uq.questionText === "Question 5_5"),
          );

          setChange((prevState) => !prevState);
        })

        .catch((err) => {});
    }

    if (googleEmail) {
      axios
        .get(
          `${apiUrl}/user-question/byGoogleUserInfo/${googleEmail}/${id}/${phase && phase.title}`,
        )
        .then((response) => {
          const sorted = response.data.sort((a, b) => b.id - a.id);

          setPrecentCompletion(sorted[0]?.questionIndex);

          const sorted1 = sorted.filter((a) => a.questionIndex === 5);
          if (
            sorted1.length > 0 &&
            sorted1[0]?.phaseName === "Phase 5" &&
            sorted1[0]?.questionNumber === "Question 5_5"
          ) {
            setPhase5Complete(true);
            setPrecentCompletion(sorted1[0]?.questionIndex);
          }
        })
        .catch((err) => {});

      axios
        .get(
          `${apiUrl}/user-question/byGoogleUserAndTheme/${encodeURIComponent(googleEmail)}/${id}`,
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          const data = response.data;

          // store only user's responses for this phase
          const phase1 = data.filter(
            (uq) =>
              uq.phaseName === "Phase 5" && googleEmail === uq.googleEmail,
          );

          // now isolate each question
          setGoogleUserQuestion5_1(
            phase1.filter((uq) => uq.questionText === "Question 5_1"),
          );
          setGoogleUserQuestion5_2(
            phase1.filter((uq) => uq.questionText === "Question 5_2"),
          );
          setGoogleUserQuestion5_3(
            phase1.filter((uq) => uq.questionText === "Question 5_3"),
          );
          setGoogleUserQuestion5_4(
            phase1.filter((uq) => uq.questionText === "Question 5_4"),
          );
          setGoogleUserQuestion5_5(
            phase1.filter((uq) => uq.questionText === "Question 5_5"),
          );

          setChange((prevState) => !prevState);
        })

        .catch((err) => {});
    }
  }, [refreshTrigger, phase, precentCompletion]);

  function phaseClick1(id11) {
    setShowPhase1((prevState) => ({
      id1: id11,
      show: !prevState.show,
    }));
  }
  return (
    <>
      <button className="phaseSection p1Sec" onClick={() => phaseClick1(5)}>
        <div className="phaseTrack">
          {phase5Complete ? (
            <h3 className="phase-status-badge completed1">Completed</h3>
          ) : (
            <h3 className="phase-status-badge in-progress">In progress</h3>
          )}

          {showPhase1.show && showPhase1.id1 === 5 ? (
            <div
              className="arrowHead upward"
              role="button"
              tabIndex={0}
              style={{
                color: "rgba(242, 237, 229, 0.78)",
                fontFamily: "sans-serif",
              }}
              // onClick={(e) => {
              //   e.stopPropagation(); // VERY IMPORTANT
              //   // setEffect(true);
              // }}
            >
              ˅
            </div>
          ) : (
            <div
              className="arrowHead downward"
              role="button"
              tabIndex={0}
              style={{
                color: "rgba(242, 237, 229, 0.78)",
                fontFamily: "sans-serif",
              }}
              // onClick={(e) => {
              //   e.stopPropagation(); // VERY IMPORTANT
              //   // setEffect(true);
              // }}
            >
              ⌵
            </div>
          )}
        </div>

        <div className="phaseArrowHeadParent phase-title-row">
          <h2 className="phase-title">
            {phase.title}: {phase.name}
          </h2>
        </div>
        <div
          style={{ color: "gray" }}
          className="phaseSectionParagraph phase-desc"
        >
          {phase.description}
          <div className="progressLineParent">
            {precentCompletion && precentCompletion === 1 ? (
              <div className="progressLineChild" style={{ width: "20%" }}></div>
            ) : precentCompletion && precentCompletion === 2 ? (
              <div className="progressLineChild" style={{ width: "40%" }}></div>
            ) : precentCompletion && precentCompletion === 3 ? (
              <div className="progressLineChild" style={{ width: "60%" }}></div>
            ) : precentCompletion && precentCompletion === 4 ? (
              <div className="progressLineChild" style={{ width: "80%" }}></div>
            ) : precentCompletion && precentCompletion === 5 ? (
              <div
                className="progressLineChild"
                style={{ width: "100%", backgroundColor: "green" }}
              ></div>
            ) : (
              <div className="progressLineChild" style={{ width: "0" }}></div>
            )}
          </div>
        </div>
        <p className="phase-progress-count">
          {precentCompletion && precentCompletion + "/" + 5}
        </p>
      </button>

      {showPhase1.show && showPhase1.id1 === 5 && (
        <>
          <div className={`phaseSecParent`}>
            {(userQuestion5_1[0] && userQuestion5_1[0]?.visited === true) ||
            (googleUserQuestion5_1[0] && googleUserQuestion5_1[0]?.visited) ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[0].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q1">
                  Session {question[0].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q1" disabled>
                Session {question[0].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}

            {(userQuestion5_2[0] && userQuestion5_2[0]?.visited === true) ||
            (googleUserQuestion5_2[0] && googleUserQuestion5_2[0]?.visited) ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[1].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q2">
                  Session {question[1].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q2" disabled>
                Session {question[1].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}

            {(userQuestion5_3[0] && userQuestion5_3[0]?.visited === true) ||
            (googleUserQuestion5_3[0] && googleUserQuestion5_3[0]?.visited) ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[2].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q3">
                  Session {question[2].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              // <div className="locked-question">
              <button className="phaseSecChild p1q1 q3" disabled>
                Session {question[2].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
              // </div>
            )}

            {(userQuestion5_4[0] && userQuestion5_4[0]?.visited === true) ||
            (googleUserQuestion5_4[0] && googleUserQuestion5_4[0]?.visited) ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[3].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q4">
                  Session {question[3].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q4" disabled>
                Session {question[3].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}

            {(userQuestion5_5[0] && userQuestion5_5[0]?.visited === true) ||
            (googleUserQuestion5_5[0] && googleUserQuestion5_5[0]?.visited) ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[4].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q5">
                  Session {question[4].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q5" disabled>
                Session {question[4].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
}
